export default __webpack_public_path__ + "img/2.b7449874.jpg";